import {
	HOME_MENU_KEY,
	TRACK_APPLICATION_MENU_KEY,
	MY_COURSES_MENU_KEY,
	MY_RESULTS_MENU_KEY,
	JOBS_MENU_KEY,
	SHORTLISTED_MENU_KEY,
	SELECTED_MENU_KEY,
} from "./menu.keys";
import type { TFunction } from "i18next";
import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";
import MonitorHeartOutlinedIcon from "@mui/icons-material/MonitorHeartOutlined";
import SchoolOutlinedIcon from "@mui/icons-material/SchoolOutlined";
import AssignmentOutlinedIcon from "@mui/icons-material/AssignmentOutlined";
import WorkOutlineIcon from "@mui/icons-material/WorkOutline";
import StarOutlineIcon from "@mui/icons-material/StarOutline";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import { BROWSER_ROUTES } from "@constants/browser.routes";

export const getSidebarMenuConfig = (t: TFunction) => {
	return [
		{
			key: HOME_MENU_KEY,
			label: t("layout.sidebar.menuName.home"),
			icon: <HomeOutlinedIcon fontSize="medium" />,
			route: BROWSER_ROUTES.DASHBOARD,
		},
		{
			key: TRACK_APPLICATION_MENU_KEY,
			label: t("layout.sidebar.menuName.trackApplication"),
			icon: <MonitorHeartOutlinedIcon fontSize="medium" />,
			route: BROWSER_ROUTES.TRACK_APPLICATION,
		},
		{
			key: MY_COURSES_MENU_KEY,
			label: t("layout.sidebar.menuName.myCourses"),
			icon: <SchoolOutlinedIcon fontSize="medium" />,
			route: BROWSER_ROUTES.MY_COURSES,
		},
		{
			key: MY_RESULTS_MENU_KEY,
			label: t("layout.sidebar.menuName.myResults"),
			icon: <AssignmentOutlinedIcon fontSize="medium" />,
			route: BROWSER_ROUTES.MY_RESULTS,
		},
		{
			key: JOBS_MENU_KEY,
			label: t("layout.sidebar.menuName.jobs"),
			icon: <WorkOutlineIcon fontSize="medium" />,
			route: "/jobs",
		},
		{
			key: SHORTLISTED_MENU_KEY,
			label: t("layout.sidebar.menuName.shortlisted"),
			icon: <StarOutlineIcon fontSize="medium" />,
			route: BROWSER_ROUTES.SHORTLISTED,
		},
		{
			key: SELECTED_MENU_KEY,
			label: t("layout.sidebar.menuName.selected"),
			icon: <CheckCircleOutlineIcon fontSize="medium" />,
			route: BROWSER_ROUTES.SELECTED,
		},
	];
};
